import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sub_menu_01" }
const _hoisted_2 = { class: "snb" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";

export default /*@__PURE__*/_defineComponent({
  __name: 'MypageSidebar',
  setup(__props) {

const { isOrgUser, isOrgAdmin } = useAuth();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(isOrgUser) || _unref(isOrgAdmin))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _createElementVNode("li", {
              class: _normalizeClass({
            active:
              _ctx.$route.name == _unref(USER_ROUTES).Mypage.Order.Org.Request.Name ||
              _ctx.$route.name == _unref(USER_ROUTES).Mypage.Order.Org.RequestList.Name,
          })
            }, [
              _createVNode(_component_router_link, {
                to: { name: _unref(USER_ROUTES).Mypage.Order.Org.RequestList.Name }
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("진단신청")
                ])),
                _: 1
              }, 8, ["to"])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({ active: _ctx.$route.name == _unref(USER_ROUTES).Mypage.Order.Org.Name })
            }, [
              _createVNode(_component_router_link, {
                to: { name: _unref(USER_ROUTES).Mypage.Order.Org.Name }
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("진단검사 관리")
                ])),
                _: 1
              }, 8, ["to"])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({
            active:
              _ctx.$route.name == _unref(USER_ROUTES).Mypage.Order.Org.PurchaseList.Name,
          })
            }, [
              _createVNode(_component_router_link, {
                to: { name: _unref(USER_ROUTES).Mypage.Order.Org.PurchaseList.Name }
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("견적(발주) 목록")
                ])),
                _: 1
              }, 8, ["to"])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({ active: _ctx.$route.name == _unref(USER_ROUTES).Mypage.User.Org.Path })
            }, [
              _createVNode(_component_router_link, {
                to: { name: _unref(USER_ROUTES).Mypage.User.Org.Name }
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("사용자 관리")
                ])),
                _: 1
              }, 8, ["to"])
            ], 2)
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _createElementVNode("li", {
              class: _normalizeClass({
            active: _ctx.$route.name == _unref(USER_ROUTES).Mypage.Order.Personal.Path,
          })
            }, [
              _createVNode(_component_router_link, {
                to: { name: _unref(USER_ROUTES).Mypage.Order.Personal.Name }
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("진단검사")
                ])),
                _: 1
              }, 8, ["to"])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({ active: _ctx.$route.name == _unref(USER_ROUTES).Mypage.Modify.Path })
            }, [
              _createVNode(_component_router_link, {
                to: { name: _unref(USER_ROUTES).Mypage.Modify.Name }
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("회원정보수정")
                ])),
                _: 1
              }, 8, ["to"])
            ], 2)
          ]))
    ])
  ]))
}
}

})